export default function PartnersSection() {
  const partners = [
    { name: "SPM Middle East Gold L.L.C.", logo: "/images/spm-logo.svg" },
    { name: "SAFE PENSION", logo: "/images/safepension-logo.png" },
    { name: "SWM AG", logo: "/images/swm-logo.png", subtitle: "seit 1947" },
  ];

  return (
    <section
      data-testid="partners-section"
      className="py-14 sm:py-20 lg:py-24 bg-[#12202f] relative"
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#3A4F60]/50 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="uppercase text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.25em] text-[#C5993A] mb-3 sm:mb-4">
          Partnerschaften
        </p>
        <h2 className="font-heading text-xl sm:text-2xl lg:text-3xl tracking-tight font-light text-white mb-4">
          VMBS UG ist Exklusivpartner von
        </h2>

        <div
          data-testid="partners-grid"
          className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-6 sm:gap-8 lg:gap-16 mt-8 sm:mt-12"
        >
          {partners.map((partner) => (
            <div
              key={partner.name}
              data-testid={`partner-${partner.name.split(" ")[0].toLowerCase()}`}
              className="flex flex-col items-center gap-2 sm:gap-3 group"
            >
              <div className="bg-white/5 border border-[#3A4F60]/30 rounded-lg p-4 sm:p-6 hover:border-[#C5993A]/30 transition-all duration-300 flex items-center justify-center h-20 w-44 sm:h-28 sm:w-52">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-14 sm:max-h-20 max-w-[150px] sm:max-w-[180px] w-auto object-contain opacity-90 group-hover:opacity-100 transition-opacity"
                />
              </div>
              <span className="text-[#8899AA] text-[10px] sm:text-xs tracking-wider">
                {partner.name}
                {partner.subtitle && (
                  <span className="block text-[#C5993A]">{partner.subtitle}</span>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
